export const STRIPE_ELEMENTS = 'stripeElements';
export const RECURLY = 'recurly';
